import {
  Component,
  OnInit,
  ElementRef,
  ChangeDetectionStrategy,
  signal,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { GameBarService } from 'src/app/services/game-bar.service';
import { animate } from 'animejs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { GameQuery } from '../../state/gameState/game.query';

@UntilDestroy()
@Component({
  selector: 'app-game-bar-component',
  templateUrl: './game-bar.component.html',
  styleUrls: ['./game-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GameBarComponent implements OnInit {
  achievement: Subscription;
  actionPoints = signal<number>(undefined);
  alliancePoint = signal<number>(undefined);
  councilPoints = signal<number>(undefined);
  countryPoints = signal<number>(undefined);
  prevActionPoints = signal<number>(null);
  prevAlliancePoints = signal<number>(null);
  prevCouncilPoints = signal<number>(null);
  prevCountryPoints = signal<number>(null);
  maxActionPoints = signal<number>(null);
  isInformational = signal(false);

  constructor(
    private elem: ElementRef,
    private gameBarService: GameBarService,
    private gameQuery: GameQuery
  ) {
    this.gameQuery.isInformational$
      .pipe(untilDestroyed(this))
      .subscribe((value) => {
        this.isInformational.set(value);
      });

    if (!this.isInformational()) {
      this.gameBarService.actionPoints
        .pipe(untilDestroyed(this))
        .subscribe((value) => {
          if (
            value.actionPoint !== this.actionPoints() &&
            !isNaN(this.actionPoints())
          ) {
            this.prevActionPoints.set(value.actionPoint - this.actionPoints());
            this.animePoints('.prev-action-points');
          }
          if (
            value.alliancePoint !== this.alliancePoint() &&
            !isNaN(this.alliancePoint())
          ) {
            this.prevAlliancePoints.set(value.alliancePoint - this.alliancePoint());
            this.animePoints('.prev-alliance-points');
          }
          if (
            value.councilPoint !== this.councilPoints() &&
            !isNaN(this.councilPoints())
          ) {
            this.prevCouncilPoints.set(value.councilPoint - this.councilPoints());
            this.animePoints('.prev-council-points');
          }
          if (
            value.countryPoint !== this.countryPoints() &&
            !isNaN(this.countryPoints())
          ) {
            this.prevCountryPoints.set(value.countryPoint - this.countryPoints());
            this.animePoints('.prev-country-points');
          }
          this.actionPoints.set(value.actionPoint);
          this.alliancePoint.set(value.alliancePoint);
          this.councilPoints.set(value.councilPoint);
          this.countryPoints.set(value.countryPoint);
          this.maxActionPoints.set(value.maxActionPoints);
        });
    }
  }

  ngOnInit() {}

  animePoints(target: string) {
    const actionPointEl = this.elem.nativeElement.querySelector(target);
    animate(target, {
      onUpdate: () => {
        setTimeout(() => {
          actionPointEl.style.display = 'block';
        }, 200);
      },
      keyframes: [
        { translateY: 0, opacity: 0 },
        { translateY: -30, opacity: 1, delay: 50, duration: 1000 },
        { translateY: -30, opacity: 0, delay: 2000, duration: 500 },
        { translateY: 0, opacity: 0 },
      ],
      ease: 'linear',
      onComplete: () => {
        actionPointEl.style.display = 'none';
      },
    });
  }
}
